import './appointment-widget.scss';

type AppointmentWidgetProps = {
	title: string;
	counter: number;
	color?: string;
};

export const AppointmentWidget: React.FC<AppointmentWidgetProps> = ({ title, counter, color = '#000000' }) => {
	return (
		<div className='appointment-widget'>
			<div className='appointment-widget-counter' style={{ color: color }}>
				{counter}
			</div>
			<div className='appointment-widget-name'>{title}</div>
		</div>
	);
};
